import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updatePricingCategoryProducts } from 'src/api/updatePricingCategoryProducts/updatePricingCategoryProducts';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { QueryKeys } from '../QueryKeys';

type TUpdateCategoryProducts = {
  priceSchemeId: string;
  categoryId: string;
  itemIds: string[];
};

export const useUpdatePricingCategoryProducts = () => {
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();

  return useMutation(
    async ({ priceSchemeId, categoryId, itemIds }: TUpdateCategoryProducts) =>
      updatePricingCategoryProducts(priceSchemeId, categoryId, {
        item_ids: itemIds,
      }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: [getBrandId(), QueryKeys.productPrices] });
        await queryClient.invalidateQueries({ queryKey: [getBrandId(), QueryKeys.pricingCategories] });
        showSnackbar({
          message: 'You have successfully updated pricing category products',
          status: SnackbarStatus.SUCCESS,
        });
      },
      onError: () => {
        showSnackbar({
          message: 'Something went wrong whilst updating pricing category products.',
          status: SnackbarStatus.ERROR,
        });
      },
    },
  );
};
